import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import {
  FaChartLine,
  FaUserGraduate,
  FaBook,
  FaUser,
  FaSignOutAlt,
  FaBars,
  FaExclamationCircle,
  FaCogs,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/vaadin_academy-cap.png";
import "../DashboardSidebar.css";

const DashboardSidebar = ({ setSelectedMainComponent }) => {
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    setCollapsed(mobile);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleItemClick = (item) => {
    setSelectedMainComponent(item);
    if (isMobile) {
      setCollapsed(true);
    }
  };

  const sidebarItems = [
    { name: "Dashboard", icon: <FaChartLine style={{ color: "white" }} /> },
    { name: "Upload Essays", icon:<FaBook style={{ color: "white" }} /> },
    { name: "Complains", icon: <FaExclamationCircle style={{ color: "white" }} /> },
    { name: "Settings", icon:<FaCogs style={{ color: "white" }} />  },
  ];

  return (
    <Sidebar collapsed={collapsed} backgroundColor="rgb(0, 23, 84)" style={{ height: "100vh", position: "fixed" }}>
      <div className="sidebar-header">
        <div className="logo-section">
          <img src={logo} alt="Logo" className="sidebar-logo" style={{ marginLeft: "10px", fontSize: "18px", marginTop: "20%" }} />
          {!collapsed && (
            <span className="sidebar-title" style={{ fontSize: "20px", marginTop: "20%", fontWeight: "bold" }}>writerswright</span>
          )}
        </div>
        {/* <button
          onClick={() => setCollapsed(!collapsed)}
          className="toggle-button"
          style={{ backgroundColor: 'rgb(0, 23, 84)', marginTop: !collapsed ? "-40px" : "10px", marginRight: !collapsed ? "10px" : "12px" }}
        >
          <FaBars style={{ color: "white", fontSize: "20px" }} />
        </button> */}
      </div>
      <Menu
        menuItemStyles={{
          button: ({ level, active }) => ({
            backgroundColor: active ? 'rgb(0, 23, 84)' : undefined,
            color: active ? 'white' : undefined,
            '&:hover': {
              backgroundColor: 'rgba(0, 23, 84, 0.8)',
              color: 'white',
            },
          }),
        }}
      >
        {sidebarItems.map((item, index) => (
          <MenuItem key={index} icon={item.icon} onClick={() => handleItemClick(item.name)} style={{ marginLeft: "10px" }}>
            <Link to={`/students-portal`} style={{ color: "white", textDecoration: "none" }}>
              {item.name}
            </Link>
          </MenuItem>
        ))}
      </Menu>
      <Menu
        className="sidebar-bottom"
        menuItemStyles={{
          button: ({ level, active }) => ({
            backgroundColor: active ? 'rgb(0, 23, 84)' : undefined,
            color: active ? 'white' : undefined,
            '&:hover': {
              backgroundColor: 'rgba(0, 23, 84, 0.8)',
              color: 'white',
            },
          }),
        }}
      >
        <MenuItem icon={<FaSignOutAlt style={{ color: "white" }} />} onClick={() => handleItemClick("Logout")}>
          {!collapsed && (
            <Link to="/" style={{ color: "white", textDecoration: "none" }}>
              Logout
            </Link>
          )}
        </MenuItem>
      </Menu>
    </Sidebar>
  );
};

export default DashboardSidebar;
